import { useMutation } from "@apollo/client";
import { TrashIcon } from "@heroicons/react/24/outline";
import { useMemo } from "react";

import { Button, IconButton, Modal } from "../../../../../../../components/ui";
import { REMOVE_INVOICE_ITEM as removeInvoiceItemMutation } from "../../../../../../../graphql/mutation/Invoice";

const Actions = props => {
  const { item, invoiceId } = props;
  const { itemId, disabled } = useMemo(() => {
    const isExported = item?.values?.exported === 1;
    const isCreditNote = item?.values?.typeId === 6;

    return { itemId: item?.id, disabled: isExported || isCreditNote };
  }, [item]);

  const [removeInvoiceItem, { loading, error, reset }] = useMutation(
    removeInvoiceItemMutation({
      instance: { edition: { artwork: { imagesSummary: { imgT: {} } } } },
      type: {},
    }),
    { refetchQueries: ["FetchItemsV2", "FetchInvoice"] },
  );

  const deleteModalProps = {
    title: "Delete Transaction",
    description: error ? "" : "Are you sure?",
    scale: "sm",
    disabled,
    closeOnBackdrop: false,
    body: ({ closeModal }) => {
      const handleDelete = async () => {
        const response = await removeInvoiceItem({
          variables: {
            input: {
              id: invoiceId,
              itemId,
            },
          },
        });

        if (response?.data?.removeInvoiceItem?.success) {
          closeModal();
        }
      };

      if (error) {
        return (
          <>
            <div className="mt-3 inline-flex items-center justify-start rounded-md border border-transparent px-4 py-2 font-bold font-medium text-red-800 sm:text-sm">
              {error?.message ||
                error?.graphQLErrors?.map?.(({ message }) => `${message} `) ||
                "An error occurred"}
            </div>
            <div className="mt-4 flex justify-end">
              <Button
                className="mr-3"
                label="Close"
                onClick={() => {
                  reset();
                  closeModal();
                }}
              />
            </div>
          </>
        );
      }

      return (
        <div className="mt-4 flex justify-end">
          <Button
            className="mr-3"
            label="Cancel"
            onClick={() => {
              closeModal();
            }}
          />
          <Button
            label={loading ? "Deleting" : "Delete"}
            disabled={loading}
            onClick={handleDelete}
          />
        </div>
      );
    },
  };

  if (!itemId || disabled) {
    return null;
  }

  return (
    <div className="user-list-actions flex text-right text-sm font-medium">
      <div className="grid grid-cols-4 gap-4">
        <Modal {...deleteModalProps}>
          <IconButton variant="clean" title={"Delete Transaction"}>
            <TrashIcon
              className={`h-4 w-4 cursor-pointer text-gray-400 ${disabled ? "cursor-default opacity-40" : ""}`}
            />
          </IconButton>
        </Modal>
      </div>
    </div>
  );
};

export default Actions;
